import localize from "helpers/localize";
import { get } from "lodash";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import EditForm from "../../../../../Components/Forms/Builder/EditForm";
import SimpleFileInput from "../../../../../Components/Forms/Fields/SimpleFile";

class TokenForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    fieldErrors: PropTypes.object,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired
  };

  handleFileChange = (remove, file) => {
    const { dispatch, change } = this.props;
    dispatch(change("file_id", remove ? null : get(file, "id", "")));
  };

  render() {
    const { isViewPage, fieldErrors } = this.props;

    const fieldError =
      fieldErrors && fieldErrors.file_id
        ? fieldErrors.file_id.join(", ")
        : null;

    return (
      <EditForm {...this.props} disableCancel={true}>
        <p>
          {localize(
            "cashregisters",
            "Az import csv ; azaz pontosvesszővel legyen elkészítve és a következő oszlopai vannak"
          )}
        </p>
        <ol>
          <li>
            <b>distributor_id</b>{" "}
            {localize(
              "cashregisters",
              "Viszonteladó rendszer azonosító (kötelező)"
            )}
          </li>
          <li>
            <b>value</b>{" "}
            {localize(
              "cashregisters",
              "Token szám (kötelező megadni, formátuma x, ahol x egy maximum 6 számjegyből álló, egész szám)"
            )}
          </li>
          <li>
            <b>valid_until</b>{" "}
            {localize(
              "cashregisters",
              "Meddig érvényes (kötelező megadni, formátuma ÉÉÉÉ.HH.NN)"
            )}
          </li>
          <li>
            <b>ap_filter</b>{" "}
            {localize("cashregisters", "AP számok , azaz vesszővel felsorolva")}
          </li>
        </ol>
        <p>
          {localize(
            "cashregisters",
            "Hiba esetén egyetlen egy adat sem kerül be az adatbázisba, valamint a rendszer megjeleníti a hiba leírását."
          )}
        </p>
        <div className="col-12">
          <SimpleFileInput
            name="file_id"
            label={localize("cashregisters", "Fájl")}
            addedFile={this.handleFileChange.bind(this, false)}
            removeFile={this.handleFileChange.bind(this, true)}
            files={[]}
            maxFiles={1}
            isViewPage={isViewPage}
            fieldError={fieldError}
            acceptedFiles=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </EditForm>
    );
  }
}

const UsersReduxForm = reduxForm({
  form: "tokens",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  updateUnregisteredFields: true,
  destroyOnUnmount: false
})(TokenForm);

export default connect(
  state => ({
    initialValues: state.eventTypes.viewData
  }),
  null
)(UsersReduxForm);
